<template>
  <div>
    <TopFeatured></TopFeatured>
  </div>
</template>

<script>
import TopFeatured from "@/components/TopFeatured";
export default {
  name: "TopfeaturedProperty",

  components: {
    TopFeatured,
  },

  data() {
    return {};
  },
};
</script>